import EFPicture from 'elem/compCommon/EFPicture';
import JoinUsI from 'elem/SVGIcon/OutdoorRecreation/JoinUsRA';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function JoinUs() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    return (
        <div id="outdoor-recreation-JoinUs" className={`outdoor-recreation-JoinUs ${css['outdoor-recreation-JoinUs']}`}>
            <div className="img-box">
                <EFPicture
                    src="/responsive/picture/outdoor-recreation/join_us_1366_au.jpg"
                    srcDesktop="/responsive/picture/outdoor-recreation/join_us_1366_au.jpg"
                    srcPad="/responsive/picture/outdoor-recreation/join_us_768_au.jpg"
                    srcMobile="/responsive/picture/outdoor-recreation/join_us_768_au.jpg"
                    alt={t('secQ')}
                />
                <div className="text-content">
                    <JoinUsI />
                    <Link
                        className="join-us-btn"
                        href="https://www.facebook.com/groups/efaustralia/"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'activity_button',
                            page_name: 'recreational-activities',
                            list_name: 'None',
                            button_name: t('secQ_btn'),
                            function: 'Join Community',
                        }}
                    >
                        {t('secQ_btn')}
                    </Link>
                    <p className="desc">{t('secQ')}</p>
                </div>
            </div>
        </div>
    );
}
